import { useField } from 'formik'
import React from 'react'

import BaseCheckbox, { CheckboxPropTypes } from '../base/form/base-checkbox'

type Props = CheckboxPropTypes & {
  name: string
  value?: any
}

function FormikCheckbox(props: Props) {
  const { value, name, ...rest } = props
  const [field] = useField({ name, value })

  return <BaseCheckbox {...rest} {...field} checked={!!field.value} />
}

export default FormikCheckbox
